import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IconNames } from '../../../../common';

@Component({
  selector: 'ui-select-profile',
  templateUrl: './monitoring-select-profile.component.html',
  styleUrls: ['./monitoring-select-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoringSelectProfileComponent {
  @Input() name: string;
  @Input() id: number;
  @Input() isUpdateProfileAvailable: boolean;
  @Input() isLabelVisible = true;
  @Input() isUpdateProfileVisible = true;
  @Input() defaultProfileControl?: FormControl<boolean>;
  @Output() removeProfile = new EventEmitter<void>();
  @Output() selectProfile = new EventEmitter<void>();
  @Output() updateProfile = new EventEmitter<void>();

  iconNameList = IconNames;
}
